import { getDomainInfos } from 'portal-common/helpers/domainUtils';
import React, { useContext } from 'react';

const DomainContext = React.createContext(null);

const useDomains = () => {
  let domains = useContext(DomainContext);
  if (!domains) domains = getDomainInfos();
  return domains;
};

export { DomainContext, useDomains };
